import { Link } from "react-router-dom";

const InfoLayout = ({ eyebrow, title, updated, children, testid }) => (
  <div className="max-w-3xl mx-auto px-6 py-16 md:py-24" data-testid={testid}>
    <p className="text-[11px] uppercase tracking-[0.28em] font-medium text-slate-400 mb-3">
      {eyebrow}
    </p>
    <h1 className="font-display text-4xl md:text-5xl font-medium tracking-tight text-slate-900 mb-3">
      {title}
    </h1>
    <p className="text-xs uppercase tracking-[0.2em] text-slate-400 mb-10">
      Son güncelleme: {updated}
    </p>
    <div className="prose prose-slate max-w-none text-slate-700 leading-relaxed space-y-6">
      {children}
    </div>
    <div className="mt-16 pt-8 border-t divider text-sm text-slate-500 flex flex-wrap gap-6">
      <Link to="/kullanim-sartlari" className="hover:text-slate-900">Kullanım Şartları</Link>
      <Link to="/gizlilik" className="hover:text-slate-900">Gizlilik Politikası</Link>
      <Link to="/kvkk" className="hover:text-slate-900">KVKK Aydınlatma Metni</Link>
    </div>
  </div>
);

const H = ({ children }) => (
  <h2 className="font-display text-xl font-medium tracking-tight text-slate-900 mt-10 mb-3">{children}</h2>
);

export function Terms() {
  return (
    <InfoLayout eyebrow="Yasal" title="Kullanım Şartları" updated="Şubat 2026" testid="terms-page">
      <p className="text-sm bg-amber-50 border border-amber-200 rounded-lg p-4">
        <strong>Not:</strong> Bu metin taslak niteliğindedir. Yayına çıkmadan önce hukuk danışmanı tarafından incelenmelidir.
      </p>
      <H>1. Genel Hükümler</H>
      <p>kolaysatis.com (&quot;Platform&quot;), kullanıcıların kendi aralarında ikinci el veya sıfır ürün alım-satımı yapabildiği bir C2C açık artırma pazar yeridir. Bu şartları kabul ederek platforma kullanıcı olarak kayıt olabilir ve hizmetlerden faydalanabilirsiniz.</p>
      <H>2. Kullanıcı Yükümlülükleri</H>
      <p>Kullanıcı; doğru, güncel ve gerçek bilgi verecek, yalnızca kendisine ait ve satışı serbest ürünleri listeleyecek, Türkiye Cumhuriyeti yasalarına aykırı hiçbir ürün, hizmet veya içerik paylaşmayacaktır. Silah, uyuşturucu, sahte marka ürünler, reçeteli ilaçlar, kaçak tütün-alkol gibi kalemler kesinlikle yasaktır.</p>
      <H>3. Komisyon ve Ücretler</H>
      <p>Platform, gerçekleşen satış tutarı üzerinden yürürlükteki oranda komisyon (bkz. Admin panel &gt; Ayarlar) uygular. Doping/öne çıkarma paketleri isteğe bağlıdır ve satın alındıklarında iade edilmez.</p>
      <H>4. Ödeme ve Havuz Hesap</H>
      <p>Ödemeler platform havuz hesabında güvenle bekletilir, alıcı teslimatı onayladığında veya belirlenen sürede itiraz gelmediğinde satıcının hakkı serbest bırakılır. Ödeme sağlayıcısı entegrasyonu Beta döneminde aktive edilecektir.</p>
      <H>5. Yasaklı Davranışlar</H>
      <p>Site dışı ödeme yönlendirmesi, iletişim bilgisi paylaşımı, sahte açık artırma katılımı (shill bidding), otomasyon/bot kullanımı, üye hesabının başkasına devri yasaktır.</p>
      <H>6. Fesih ve Cezalar</H>
      <p>Platform, yukarıdaki kuralları ihlal eden kullanıcıların hesabını süreli veya süresiz askıya alma hakkını saklı tutar. Ağır ihlallerde ilgili makamlara bilgi verilir.</p>
      <H>7. İletişim</H>
      <p>Sorularınız için <a href="mailto:destek@kolaysatis.com" className="text-[#B54037]">destek@kolaysatis.com</a> adresinden bize ulaşabilirsiniz.</p>
    </InfoLayout>
  );
}

export function Privacy() {
  return (
    <InfoLayout eyebrow="Yasal" title="Gizlilik Politikası" updated="Şubat 2026" testid="privacy-page">
      <p className="text-sm bg-amber-50 border border-amber-200 rounded-lg p-4">
        <strong>Not:</strong> Bu metin bilgilendirme amaçlı taslak niteliğindedir.
      </p>
      <H>1. Topladığımız Veriler</H>
      <p>Kullanıcı adı, e-posta, T.C. kimlik numarası (doğrulama için), telefon (opsiyonel), IP adresi ve tarayıcı bilgileri, platform içi davranış (aramalar, favoriler, teklifler, mesajlar) gibi verileri işleyebiliriz.</p>
      <H>2. Kullanım Amacı</H>
      <p>Verileriniz; hesap oluşturma, kimlik doğrulama, dolandırıcılık önleme, iletişim, öneri motoru (Faz 4B), yasal yükümlülükler ve platform güvenliği amaçlarıyla işlenir.</p>
      <H>3. Çerezler</H>
      <p>Oturum yönetimi, kişiselleştirme ve temel analytics amacıyla çerezler kullanırız. Tarayıcı ayarlarınızdan çerezleri devre dışı bırakabilirsiniz — ancak bazı özellikler çalışmayabilir.</p>
      <H>4. Üçüncü Taraflar</H>
      <p>Ödeme sağlayıcı (Stripe), e-posta servisi (Resend/SendGrid — yakında), analytics ve AI moderasyon (Emergent LLM Key) sağlayıcıları ile veri paylaşabiliriz. Tüm iş ortaklarımızla veri koruma anlaşmaları imzalanır.</p>
      <H>5. Veri Saklama Süresi</H>
      <p>Verileriniz, hesabınız açık kaldığı sürece ve/veya yasal yükümlülüklerin gerektirdiği süreyle saklanır.</p>
      <H>6. Haklarınız</H>
      <p>KVKK madde 11 kapsamındaki tüm haklarınızı kullanmak için <a href="mailto:kvkk@kolaysatis.com" className="text-[#B54037]">kvkk@kolaysatis.com</a> adresine yazabilirsiniz.</p>
    </InfoLayout>
  );
}

export function Kvkk() {
  return (
    <InfoLayout eyebrow="Yasal" title="KVKK Aydınlatma Metni" updated="Şubat 2026" testid="kvkk-page">
      <p className="text-sm bg-amber-50 border border-amber-200 rounded-lg p-4">
        <strong>Not:</strong> Bu metin bilgilendirme amaçlı taslak niteliğindedir. Yayın öncesi hukuk danışmanı tarafından güncellenecektir.
      </p>
      <H>Veri Sorumlusu</H>
      <p>6698 Sayılı Kişisel Verilerin Korunması Kanunu (&quot;KVKK&quot;) uyarınca, veri sorumlusu sıfatıyla kolaysatis.com işletmesi tarafından, aşağıda belirtilen kişisel verileriniz KVKK&apos;ya uygun olarak işlenebilecektir.</p>
      <H>İşlenen Kişisel Veri Kategorileri</H>
      <p>Kimlik (ad-soyad, T.C. kimlik numarası), iletişim (e-posta, telefon), müşteri işlem verileri (ilanlar, teklifler, ödemeler), pazarlama verileri (öneri motoru sinyalleri), işlem güvenliği verileri (IP, log kayıtları).</p>
      <H>İşleme Amaçları</H>
      <p>Hesap oluşturma ve doğrulama, platform içi hizmetlerin yürütülmesi, güvenlik ve dolandırıcılık önleme, yasal yükümlülüklerin yerine getirilmesi, iletişim ve pazarlama (izin verdiyseniz), ürün ve hizmetlerin iyileştirilmesi.</p>
      <H>Aktarım</H>
      <p>Kişisel verileriniz; yasal zorunluluklar (mahkeme, kolluk kuvveti), ödeme sağlayıcılar, e-posta ve bulut altyapı sağlayıcıları ile yalnızca hizmet gereklilikleri ölçüsünde paylaşılabilir. Yurt dışına aktarım gereken durumlarda KVKK madde 9 uyarınca ek onay alınır.</p>
      <H>Toplama Yöntemi ve Hukuki Sebep</H>
      <p>Verileriniz; elektronik ortamda, web sitesi formları, çerezler, mobil uygulamalar aracılığıyla ve kısmen otomatik olarak toplanır. Hukuki sebep KVKK madde 5/2 (c), (ç), (e), (f) bentleri ile ilgili maddelerdir.</p>
      <H>KVKK Madde 11 Kapsamındaki Haklarınız</H>
      <ul className="list-disc pl-6 space-y-1.5 text-sm">
        <li>Kişisel verilerinizin işlenip işlenmediğini öğrenme</li>
        <li>İşlenmişse buna ilişkin bilgi talep etme</li>
        <li>Amacına uygun kullanılıp kullanılmadığını öğrenme</li>
        <li>Yurt içinde/dışında aktarıldığı üçüncü kişileri bilme</li>
        <li>Eksik/yanlış işlenmişse düzeltilmesini isteme</li>
        <li>KVKK madde 7&apos;de öngörülen şartlar çerçevesinde silinmesini/yok edilmesini isteme</li>
        <li>Otomatik sistemler ile analiz edilmesi nedeniyle aleyhinize doğan sonuca itiraz etme</li>
        <li>Zarara uğramanız halinde tazminat talep etme</li>
      </ul>
      <H>Başvuru</H>
      <p>Yukarıdaki haklarınızı kullanmak için <a href="mailto:kvkk@kolaysatis.com" className="text-[#B54037]">kvkk@kolaysatis.com</a> adresine e-posta gönderebilirsiniz.</p>
    </InfoLayout>
  );
}
